// eslint-disable-next-line
const prefixWith = (prefix, routes) => routes.map(route => ({ ...route, path: prefix + route.path }));


const routes = [
  {
    path: '/case-study',
    component: () => import('./layouts/default'),
    children: [
      {
        path: ':activeItem?',
        component: () => import('./pages/case-study'),
        props: true,
      },
    ],
  },
  {
    path: '/about',
    component: () => import('./layouts/default'),
    children: [
      {
        path: '',
        component: () => import('./pages/about'),
      },
    ],
  },
  {
    path: '/contact',
    component: () => import('./layouts/default'),
    children: [
      {
        path: '',
        component: () => import('./pages/contact'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('./layouts/default'),
    children: [
      {
        path: '',
        component: () => import('./pages/home'),
      },
    ],
  },
  {
    // Always leave this as last one
    path: '*',
    component: () => import('./pages/404'),
  },
];

const prefixed = prefixWith('/:locale?', routes);

export default prefixed;
